var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AptiveIcon } from '@aptive-env/storybook';
var Direction = function (_a) {
    var sort = _a.sort;
    return (_jsxs("div", __assign({ className: "relative w-[16px] h-[16px]" }, { children: [_jsx(AptiveIcon, { className: "absolute -top-1 w-[16px] h-[16px] stroke-[#4b5563] fill-none ".concat(sort > 0 ? '!stroke-[#030712]' : ''), icon: 'chevronUp' }), _jsx(AptiveIcon, { className: "absolute -bottom-1 w-[16px] h-[16px] stroke-[#4b5563] fill-none ".concat(sort < 0 ? '!stroke-[#030712]' : ''), icon: 'chevronDown' })] })));
};
export default Direction;
